import { SALES_PARTNER_TYPE_BROKER, SALES_PARTNER_TYPE_PRIVATE_INSURER } from '@/config/constants'

export const PartnerUtil = {
  isBroker(partnerData) {
    return partnerData?.salesPartnerType === SALES_PARTNER_TYPE_BROKER
  },

  getAdvisorFullName({ lastName, firstName }) {
    return `${lastName} ${firstName}`
  },

  hasSalesPartnerEmail(salesPartnerType) {
    return [SALES_PARTNER_TYPE_BROKER, SALES_PARTNER_TYPE_PRIVATE_INSURER].includes(salesPartnerType)
  },
}
